// @ts-nocheck
import React, { Component, memo } from 'react';
import { withTranslation } from 'react-i18next';

import { RootContext, StateContext } from '@/root/root.provider';
import { T } from '@/v2/helpers/i18n';

import './header.module.scss';
import { TicketTopSectionGeneric } from '@ticketmaster/global-design-system';
import { ProductModel } from '@/v2/models/productModel.ts';

type Props = {
  product: ProductModel;
} & T;

class ProductHeader extends Component<Props, State> {
  static contextType: React.Context<StateContext> = RootContext;

  render() {
    const { product } = this.props;

    const showInfo = () => {
      this.context.setActiveProductId(product.id);
      this.context.setActiveTicketId(null);
      this.context.setShowInfo(true);
    };

    const status = product.voidedAt ? 'disabled' : 'primary';

    return (
      <TicketTopSectionGeneric
        headerTitle={product.productName}
        mainText={product.productVariantName}
        type={status}
        ticketInfoButtonData={{ callback: showInfo, accessibleDescription: 'Show info' }}
      />
    );
  }
}

export default withTranslation('translation')(memo(ProductHeader));
